export default __webpack_public_path__ + "static/media/ossscreen7.8c825fbe.png";